module.exports = __webpack_public_path__ + "img/koffein.ca62124d.png";